module.exports = __webpack_public_path__ + "static/media/sidemenu.ea501123.svg";